<script setup>
import { ref, reactive, onMounted } from "vue";
import {
  queryCameraAccountPage,
  deleteCameraAccount,
} from "@/api/cameraConfig";
import { ElMessage, ElMessageBox } from "element-plus";
import Adjust from "./adjust.vue";

// 页面标题
const title = ref("摄像头账号配置");

// 搜索条件ref
const searchRef = ref(null);

// 编辑组件ref
const adjustRef = ref(null);

// 搜索条件
const searchData = reactive({
  title: null,
});

// 分页配置
const pages = reactive({
  page: 1,
  limit: 10,
  total: 0,
});

// 表格loading
const tableLoading = ref(false);

// 表格列配置
const columns = ref([
  {
    label: "主机地址",
    prop: "host",
  },
  {
    label: "标题",
    prop: "title",
  },
  {
    label: "分配组织",
    prop: "plantsIds",
  },
  {
    label: "appKey",
    prop: "appKey",
  },
  {
    label: "appSecret",
    prop: "appSecret",
  },
  {
    label: "备注",
    prop: "remark",
  },
]);

// 表格数据
const tableData = ref([]);

// 获取数据
const getList = () => {
  tableLoading.value = true;
  queryCameraAccountPage({
    ...searchData,
    page: pages.page,
    limit: pages.limit,
  })
    .then((res) => {
      tableData.value = res.data.records;
      pages.total = res.data.total;
    })
    .finally(() => {
      tableLoading.value = false;
    });
};

// 重置
const searchReset = () => {
  searchRef.value?.resetFields();
  getList();
};

// 点击新增、编辑
const handleAdjust = (row, type) => {
  adjustRef.value?.handleDialogOpen(row, type);
};

// 点击删除
const handleDelete = (row) => {
  ElMessageBox.confirm(`确定删除${row.title}?`, "警告", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "error",
  })
    .then(() => {
      deleteCameraAccount(row.id).then((res) => {
        if (res.code == "2000") {
          ElMessage.success("操作成功");
          getList();
        }
      });
    })
    .catch(() => {});
};

onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title }">
    <template #header-btn>
      <el-button type="primary" icon="Plus" @click="handleAdjust(null, 'add')"
        >新增</el-button
      >
    </template>
    <template #search>
      <el-form ref="searchRef" :model="searchData" :inline="true">
        <el-form-item label="标题" prop="title">
          <el-input v-model="searchData.title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="getList()"
            >查询</el-button
          >
          <el-button icon="Refresh" @click="searchReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        v-loading="tableLoading"
      >
        <el-table-column type="index" label="序号" width="60" />
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
          />
        </template>
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleAdjust(row, 'edit')"
              >编辑</el-button
            >
            <el-button type="danger" link @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="pages.total > 0"
        :total="pages.total"
        v-model:current-page="pages.page"
        @update:current-page="getList"
        layout="->, prev, pager, next"
      />
    </template>
  </zh-table-page>
  <!-- 新增、编辑组件 -->
  <adjust ref="adjustRef" @afterSave="getList" />
</template>

<style lang="scss" scoped></style>
